

export class MenuListInput implements IMenuListInput {
    /** The auto-generated id of the application sub menu master */
    applicationSubMenuId!: number;
    /** The action  of 0 for no access, 1 for view, 2 for full access */
    actionType!: number;

    constructor(data?: IMenuListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationSubMenuId = _data["applicationSubMenuId"];
            this.actionType = _data["actionType"];
        }
    }

    static fromJS(data: any): MenuListInput {
        data = typeof data === 'object' ? data : {};
        let result = new MenuListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationSubMenuId"] = this.applicationSubMenuId;
        data["actionType"] = this.actionType;
        return data; 
    }
}

export interface IMenuListInput {
    /** The auto-generated id of the application sub menu master */
    applicationSubMenuId: number;
    /** The action  of 0 for no access, 1 for view, 2 for full access */
    actionType: number;
}

